export default __webpack_public_path__ + "static/media/Dean Wesrey.12b20844.jpg";